import { Group, Paper, Stack, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { IntegrationInstallationsTable, SearchInput } from '../../../components';
import { useIntegrationInstallations } from '../../../queries/use-integration-installations';
import { useTableState } from '../../../hooks/use-table-state';
import { PAGE_SIZE } from '../../../magic-values';
import type { IntegrationInstallation } from '../../../types/integration-installation';

interface IntegrationsTabProps {
  accountId: string;
}

export function IntegrationsTab({ accountId }: IntegrationsTabProps) {
  const navigate = useNavigate();
  const { page, sortBy, sortDir, sortStatus, filterBy, setPage, setSortStatus, setFilterBy } =
    useTableState();
  const { data, isLoading, isError, error } = useIntegrationInstallations(
    filterBy ? { accountId, filterBy } : { accountId },
    { page, pageSize: PAGE_SIZE, sortBy, sortDir },
  );
  const installations = data?.items ?? [];

  const handleRowClick = (installation: IntegrationInstallation) => {
    navigate(`/account/${accountId}/integration/${installation._id}`);
  };

  return (
    <Stack spacing="sm">
      <Group position="right">
        <SearchInput value={filterBy} onChange={setFilterBy} placeholder="Search integrations…" />
      </Group>
      {isError ? (
        <Text color="red">
          Failed to load integrations: {(error as Error)?.message ?? 'Unknown error'}
        </Text>
      ) : (
        <Paper withBorder sx={{ overflowX: 'auto' }}>
          <IntegrationInstallationsTable
            installations={installations}
            fetching={isLoading}
            onRowClick={handleRowClick}
            page={page}
            totalRecords={data?.total ?? 0}
            onPageChange={setPage}
            sortStatus={sortStatus}
            onSortStatusChange={setSortStatus}
            height="calc(100vh - 500px)"
          />
        </Paper>
      )}
    </Stack>
  );
}
